import NearbyLoading from 'features/rewards/RewardsHome/components/NearByLoading';
import { VXLNode } from 'shared/renderer/types';

const nearbyLoadingNode = (id: string): VXLNode => ({
  id,
  render: NearbyLoading,
});

export default nearbyLoadingNode;
